export default {
  colorPrimary: '#FF7802',
  colorDarkBlue: '#0B1A27',
  colorLightGrey: '#DEDFE0',
  colorTransitBlue: '#2b3990',
  fontHeader: 'DINOT',
  fontMain: 'garamond-premier-pro',
};



// WEBPACK FOOTER //
// ./src/styles/theme.js